export const MIN_LATITUDE_EARTH = -90
export const MAX_LATITUDE_EARTH = 90
export const MIN_LONGITUDE_EARTH = -180
export const MAX_LONGITUDE_EARTH = 180

export default function computeSuperBoundaryBox(boxA, boxB) {
  // Here, given two sets of boundaries, both nullable,
  // we compute a the smallest superset of boundaries that contains each non-null set.
  // If both sets are null, we default to a superset that includes the entire map.
  // Boundary sets are expected to be objects with keys: minLatitude, maxLatitude, minLongitude, maxLongitude
  if (!boxA && !boxB) {
    return {
      minLatitude: MIN_LATITUDE_EARTH,
      maxLatitude: MAX_LATITUDE_EARTH,
      minLongitude: MIN_LONGITUDE_EARTH,
      maxLongitude: MAX_LONGITUDE_EARTH
    }
  }
  if (!boxA) {
    return boxB
  }
  if (!boxB) {
    return boxA
  }
  return {
    minLatitude: Math.min(boxA.minLatitude, boxB.minLatitude),
    maxLatitude: Math.max(boxA.maxLatitude, boxB.maxLatitude),
    minLongitude: Math.min(boxA.minLongitude, boxB.minLongitude),
    maxLongitude: Math.max(boxA.maxLongitude, boxB.maxLongitude)
  }
}
